import { OnepasswordIcon } from './OnepasswordIcon';

/**
 * author: Contributors
 * id 2B9B64C7-B799-45C5-BDCC-BEC3B8672CFE
 * name onepassword
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/onepassword.svg
 * tags
 * - Brand / Logo 
 */
export const _1passwordIcon = OnepasswordIcon;
export default _1passwordIcon